import tmsApi from './../api/tmsApi';

const notifTypes = {
  ALERT: 'ALERT',
  MESSAGE: 'MESSAGE',
  REPORT: 'REPORT',
  UPDATE: 'UPDATE',
};

export default {
  namespaced: true,
  state: {
    notifications: [],
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.notifications.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.notifications.push(data);
    },
    ADD_DATA_ON_EXISTING_LIST(state, data) {
      data.id = data.id.toString();
      const { id } = data;
      const index = state.notifications.findIndex(n => (n.id === id));

      if (index > -1) {
        state.notifications.splice(index, 1, data);
      } else {
        state.notifications.unshift(data);
      }
    },
    REMOVE_DATA_ON_LIST(state, id) {
      const index = state.notifications.findIndex(n => (n.id === id));
      if (index > -1) {
        state.notifications.splice(index, 1);
      }
    },
    ADD_ERROR(state, error) {
      state.errors.actions.push(error);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
  },
  getters: {
    notifications(state) {
      return state.notifications;
    },
    alerts(state) {
      return state.notifications
        .filter(n => n.type === notifTypes.ALERT);
    },
    messages(state) {
      return state.notifications
        .filter(n => n.type === notifTypes.MESSAGE);
    },
    reports(state) {
      return state.notifications
        .filter(n => n.type === notifTypes.REPORT);
    },
    updates(state) {
      return state.notifications
        .filter(n => n.type === notifTypes.UPDATE);
    },
  },
  actions: {
    LOAD_DATA({ commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          notifications {
            id
            key
            title
            occurence
            type
            metadata
            created_at
            updated_at
          }
        }
      `;
      commit('CLEAR_DATA');
      return api(query, 'notifications').then(({ data }) => {
        const { notifications } = data;
        notifications.forEach((notif) => {
          commit('ADD_DATA_ON_LIST', notif);
        }, this);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DATA');
      });
    },
    DELETE_NOTIFICATION({ commit, rootState }, id) {
      const api = tmsApi.build(rootState.token);
      const query = `
        mutation {
          result: delete_notification(id: ${id})
        }
      `;
      return api(query, 'notifications').then(({ data }) => {
        if (data.result) {
          commit('REMOVE_DATA_ON_LIST', id);
        }
        return data.result;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_NOTIFICATION');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/notifications.js